﻿declare function require(name: string): any;

class LazzyLoaders {
    private _reg = {};

    loadMoment() {
        if (!this._reg.hasOwnProperty('moment')) {
            require('moment');
            this._reg['moment'] = true;
        }
        return this;
    }

    //ATTENTION: les 'require' doivent etre ecrit textuellement afin de fonctionner.

    //loadBootstrap() {
    //    if (!this._reg.hasOwnProperty('bootstrap')) {
    //        require('bootstrap');
    //        this._reg['bootstrap'] = true;
    //    }
    //    return this;
    //}

    //loadBootstrapDatepicker() {
    //    this.loadBootstrap();
    //    if (!this._reg.hasOwnProperty('bootstrap-datepicker')) {
    //        require('bootstrap-datepicker');
    //        this._reg['bootstrap-datepicker'] = true;
    //    }
    //    return this;
    //}

    //loadBootstrapMultiselect() {
    //    if (!this._reg.hasOwnProperty('bootstrap-multiselect')) {
    //        this.loadBootstrap();
    //        require('bootstrap-multiselect');
    //        this._reg['bootstrap-multiselect'] = true;
    //    }
    //    return this;
    //}
}

export = new LazzyLoaders();